<template>
  <div class="flex flex-col justify-between">
    <h1 class="w-full bg-beige-academy-300 text-white text-center
    tracking-widest uppercase py-6 text-lg mb-2">
      {{$t('editingSlots.areYouSure')}}
    </h1>
    <div class="flex flex-row justify-between my-2 text-sm w-1/2 mx-auto pb-6 pt-3">
        <modal-button @click="$modal.hide('delete')"
        :buttonPlaceholder="$t('bookingSlots.cancel')"
        buttonClass="uppercase" />
        <modal-button @click="deleteSlot(slotId)"
        :buttonPlaceholder="$t('editingSlots.delete')"
        buttonClass="uppercase" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import ModalButton from '../graphics/ModalButton.vue';

export default {
  props: ['slotId'],

  components: {
    ModalButton,
  },

  methods: {
    deleteSlot(slotId) {
      axios.delete(`/api/slots/${slotId}`).then(() => {
        this.$modal.hide('delete');
        this.$emit('deleted');
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorTryAgain'));
      });
    },
  },
};
</script>
